package co.maytes.standupbot.dashboard.components.layout

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.widgets.TocItem
import co.maytes.standupbot.dashboard.components.widgets.TocSidebar
import co.maytes.standupbot.dashboard.styles.Spacing
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

@Composable
fun LegalLayout(
    title: String,
    lastUpdated: String,
    summary: String,
    toc: List<TocItem>,
    content: @Composable () -> Unit,
) {
    Div {
        LegalHero(title = title, lastUpdated = lastUpdated, summary = summary)
        Div(
            attrs = Modifier
                .classNames("sb-legal-layout")
                .padding(bottom = Spacing.x4l)
                .toAttrs(),
        ) {
            TocSidebar(items = toc, quiet = true)
            Div(attrs = { classes("sb-legal-prose") }) { content() }
        }
    }
}

@Composable
private fun LegalHero(title: String, lastUpdated: String, summary: String) {
    Div(attrs = { classes("mk-legal-hero") }) {
        H1(attrs = { classes("mk-legal-title") }) { Text(title) }
        Div(attrs = { classes("mk-legal-meta") }) {
            MetaRow(label = "Last updated", value = lastUpdated)
            MetaRow(label = "Jurisdiction", value = "NSW, Australia")
            MetaRow(label = "Audience", value = "Workspace admin")
        }
        if (summary.isNotBlank()) SummaryCallout(summary)
    }
}

@Composable
private fun MetaRow(label: String, value: String) {
    Div(attrs = { classes("mk-legal-meta-row") }) {
        Span(attrs = { classes("mk-legal-meta-label") }) { Text(label) }
        Span(attrs = { classes("mk-legal-meta-value") }) { Text(value) }
    }
}

@Composable
private fun SummaryCallout(text: String) {
    Div(attrs = { classes("mk-legal-summary") }) {
        H2(attrs = { classes("mk-legal-summary-title") }) { Text("The short version") }
        P(attrs = { classes("mk-legal-summary-body") }) { Text(text) }
    }
}

@Composable
fun LegalSection(
    index: Int,
    anchor: String,
    title: String,
    body: String? = null,
    extra: @Composable (() -> Unit)? = null,
) {
    Div(attrs = { classes("mk-legal-section"); id(anchor) }) {
        Span(attrs = { classes("mk-legal-num") }) { Text(index.toString().padStart(2, '0')) }
        H2(attrs = { classes("mk-legal-section-title") }) { Text(title) }
        if (body != null) P(attrs = { classes("mk-legal-body") }) { Text(body) }
        if (extra != null) Div(attrs = { classes("mk-legal-extra") }) { extra() }
    }
}

@Composable
fun LegalBullets(items: List<String>) {
    Ul(attrs = { classes("mk-legal-bullets") }) {
        items.forEach { item -> Li { Span { Text(item) } } }
    }
}
